module.exports = __webpack_public_path__ + "img/qrcode.b8175ae8.jpg";